<template>
  <div class="product-first">
    <div class="product-first-cell">
      <img class="gold" src="@/assets/imgs/gold.png" alt="">
      <img class="golds" src="@/assets/imgs/golds.png" alt="">
      <div class="product-first-cell-center">
        <div class="product-first-cell-center-title">
          伦敦金
        </div>
        <span class="product-first-cell-center-line"></span>
        <div>
          伦敦金是由伦敦国际金融期货交易所提供的一种交易产品，是一种黄金交易方式的名称。<br />
          伦敦金产品简易，门槛较低，全球通行，买涨买跌皆可获利，24小时运作，网上电子交易快捷又安全。
        </div>
      </div>
    </div>
    <div class="product-first-cell">
      <img class="sliver" src="@/assets/imgs/silver.png" alt="">
      <img class="slivers" src="@/assets/imgs/slivers.png" alt="">
      <div class="product-first-cell-center">
        <div class="product-first-cell-center-title">
          伦敦银
        </div>
        <span class="product-first-cell-center-line"></span>
        <div>
          伦敦银与伦敦金一样，伦敦银也是一种24小时买卖的产品，交易规则简单，T+0操作，资金结算时间短。<br />
          全球的主要市场包括：伦敦、苏黎世、纽约、芝加哥及香港等地。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'productFirst',

 
}
</script>

<style lang="less" scoped>
  .product-first {
    &-cell {
      position: relative;
      padding-top: 30px;
      margin-bottom: 60px;
      .gold,.sliver{
         display: block;
      }
       .golds,.slivers{
         display: none;
      }
      >img {
        position: absolute;
        width: 606px;
        height: 336px;
        top: 0;
        right: 0;
      }

      &:first-child {
        >img {
          left: 0;
        }

        .product-first-cell-center {
          margin-left: 2%;
          padding: 70px 50px 0 52%;
        }
      }
      
      &-center {
        background: #FF3333;
        color: #FFFFFF;
        width: 98%;
        height: 340px;
        padding: 70px 52% 0 50px;
        box-sizing: border-box;
        line-height: 30px;

        &-title {
          font-size: 26px;
          font-weight: 700;
        }

        &-line {
          width: 40px;
          height: 4px;
          background: #FFFFFF;
          display: inline-block;
          margin: 25px 0 10px;
        }
      }
    }
  }
  @media screen and (max-width: 500px) {
    .product-first {
    &-cell {
     
      .gold,.sliver{
         display: none;
      }
       .golds,.slivers{
         display: block;
      }
       .slivers{
        margin: 0 auto;
        left: 0;
       }
      >img {
        width: 343px;
        height: 182px;
        margin: 0 auto;
      }
      &:first-child {
        >img {
          left: 0;
        }

        .product-first-cell-center {
          margin: 0 auto;
          // margin-left: 4%;
          padding: 156px 50px 0 4%;
        }
      }
      &-center {
        padding: 156px 2% 0 18px;
        font-size: 12px;
        margin: 0 auto;
        width: 343px;
        height: 280px;
        line-height: 17px;
        &-title {
          font-size: 14px;
        }
        &-line{
          height: 2px;
          margin: 6px 0;
        }
      }
  }
 }
}
// -------------------------小屏幕适配-------------------
@media screen and (min-width: 1264px) and (max-width: 1724px) {
  .product-first {
      &-cell {
        position: relative;
        padding-top: 30px;
        margin-bottom: 60px;
  
        .gold,
        .sliver {
          display: block;
        }
  
        .golds,
        .slivers {
          display: none;
        }
  
        >img {
          position: absolute;
          width: 506px;
          height: 336px;
          top: 0;
          right: 0;
        }
  
        &:first-child {
          >img {
            left: 0;
          }
  
          .product-first-cell-center {
            margin-left: 2%;
            padding: 70px 50px 0 52%;
          }
        }
  
        &-center {
          background: #FF3333;
          color: #FFFFFF;
          width: 98%;
          height: 340px;
          padding: 70px 52% 0 50px;
          box-sizing: border-box;
          line-height: 30px;
  
          &-title {
            font-size: 26px;
            font-weight: 700;
          }
  
          &-line {
            width: 40px;
            height: 4px;
            background: #FFFFFF;
            display: inline-block;
            margin: 25px 0 10px;
          }
        }
      }
    }
}
</style>